import ROUTERCONFIG from 'router-config/htdocs/js/wifi-configuration';

angular.module("SupportAgent")
.controller(
'routerConfigCtr',
 ['$rootScope', '$scope', 'EventHandler', '$timeout',
  'INTERACT','L',
 function ($rootScope, $scope, EventHandler, $timeout, INTERACT,L) {
  $scope.updateRouterConfigValue = function(info) {
   L.trace({info:info},"updateRouterConfigValue");
   EventHandler.APILAYER.sendMessage({
    convid: +$rootScope.conversationID,
    channelid: INTERACT.D.xaction.channel.dagreq,
    msg: "9|setvalue|"+JSON.stringify(info),// TODO: magic
    devid: +$rootScope.deviceID
   });
  };
  ROUTERCONFIG.getString = function(id){
     return $rootScope.getString(id);
  };
  ROUTERCONFIG.init($scope);
  ROUTERCONFIG.root_path = "/";
  $rootScope.loadRouterConfiguration = function(data) {
   ROUTERCONFIG.loadData($scope, data);
   ROUTERCONFIG.controller($scope ,$rootScope, $timeout,$scope.updateRouterConfigValue);
  };
 }]);
